import DOMPurify from 'dompurify';

export function purify(html: string): string {
  return DOMPurify.sanitize(html);
}
